interface EvaluationInfoSectionProps {
  isDark: boolean;
  title: string;
  weight: string;
  dueDate: string;
  onTitleChange: (value: string) => void;
  onWeightChange: (value: string) => void;
  onDateChange: (value: string) => void;
}

export const EvaluationInfoSection: React.FC<EvaluationInfoSectionProps> = ({
  isDark,
  title,
  weight,
  dueDate,
  onTitleChange,
  onWeightChange,
  onDateChange,
}) => {
  return (
    <>
      <div className="col-span-full bg-(--card-bg) border border-(--border-color) rounded-2xl p-6 shadow-sm mb-2">
        <div className="space-y-8">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
              Título ou Tema da Atividade
            </label>
            <input
              type="text"
              placeholder="Ex: Revolução Industrial e seus Impactos"
              value={title}
              onChange={(e) => onTitleChange(e.target.value)}
              className="w-full rounded-xl border border-(--border-color) p-4 focus:ring-2 focus:ring-blue-500/20 focus:border-(--primary-color) outline-none font-semibold text-lg transition-all hover:border-(--text-tertiary) text-(--text-primary) bg-(--card-bg)"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
                Pontuação Total
              </label>
              <input
                type="number"
                step="0.5"
                min="0"
                value={weight}
                onChange={(e) => onWeightChange(e.target.value)}
                className="w-full rounded-xl border border-(--border-color) p-3.5 focus:ring-2 focus:ring-blue-500/20 focus:border-(--primary-color) outline-none transition-all hover:border-(--text-tertiary) font-medium text-(--text-primary) bg-(--card-bg)"
                placeholder="Ex: 10.0"
              />
            </div>

            <div>
              <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
                Data Programada
              </label>
              <input
                type="date"
                value={dueDate}
                onChange={(e) => onDateChange(e.target.value)}
                className="w-full rounded-xl border border-(--border-color) p-3.5 focus:ring-2 focus:ring-blue-500/20 focus:border-(--primary-color) outline-none transition-all hover:border-(--text-tertiary) font-medium text-(--text-primary) bg-(--card-bg)"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
